<template>
  <div>
    <div v-show="showMobile" class="add-to-cart-mobile">
      <div class="cart-actions-wrapper">
        <ProductAddToCart
          :mobile="true"
          :use-icon="true"
          :product="product"
          :quantity="quantity"
          :show-heart-icon="showHeartIcon"
          @set-quantity="setQuantity"
        />
      </div>
    </div>
    <div class="add-to-cart-mid-page">
      <ProductAddToCart
        :use-icon="true"
        :product="product"
        :quantity="quantity"
        @set-quantity="setQuantity"
      />
    </div>
  </div>
</template>

<script>
export default {
  components: {
    ProductAddToCart: defineAsyncComponent(
      () => import('@/components/Product/PDP/ProductAddToCart'),
    ),
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
    showMobile: {
      type: Boolean,
      default: true,
    },
    showHeartIcon: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      quantity: 1,
    }
  },
  methods: {
    setQuantity(newValue) {
      this.quantity = newValue
    },
  },
}
</script>
